import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid'
import FiltersSection from '../Filters/FiltersSection'
import withStyles from '@material-ui/core/styles/withStyles'
import connect from "react-redux/es/connect/connect";
import classNames from 'classnames';
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import {getEstatisticaEtapa, getOSContagemPorTipoPergunta} from "../../actions/orderActions";
import ConsertoKPI from "./ConsertoKPIs";
import OSRespostasBarChart from "../../components/OSRespostasBarChart";
import Typography from "@material-ui/core/Typography";
import OSRespostasPieChart from "../../components/OSRespostasPieChart";
import OSESeriesDHChart from "../../components/OSESeriesDHChart";

//const stations = [1,2,3,4]

const styles = theme => ({
    dashboardSection: {
        // padding: "5px"
    },
    sectionTitle: {
        marginBottom: theme.spacing(1) * 4,
        marginTop: theme.spacing(1) * 4
    },
    marginTop: {
      marginTop: theme.spacing(1) * 4
    },
    marginBottom: {
      marginBottom: theme.spacing(1) * 5,


    },
    marginBottomCharts: {
        margin: theme.spacing(1) * 3,
    },
    marginRight: {
      paddingRight: theme.spacing(1) * 2
    },
    progress: {
        margin: theme.spacing(1) * 2,
    },
});

class Conserto extends Component {
    constructor(props) {
        super(props);


        // document.title = 'Conserto';

        this.renderContent = this.renderContent.bind(this);
        this.renderLoadingScreen = this.renderLoadingScreen.bind(this);
        this.onFilterClick = this.onFilterClick.bind(this);
    }

    componentDidMount(): void {
        this.props.getEstatisticaEtapa(12);
        this.props.getOSContagemPorTipoPergunta(121);
        this.props.getOSContagemPorTipoPergunta(122);
        this.props.getOSContagemPorTipoPergunta(123);
    }

    onFilterClick = () => {
        this.props.getEstatisticaEtapa(12);
        this.props.getOSContagemPorTipoPergunta(121);
        this.props.getOSContagemPorTipoPergunta(122);
        this.props.getOSContagemPorTipoPergunta(123);
    }


    componentDidUpdate(oldProps, oldState){
        //if (oldProps.filter.)

        // if (JSON.stringify(oldProps.filter) !== JSON.stringify(this.props.filter)) {
        //     this.props.getEstatisticaEtapa(12);
        //     this.props.getOSContagemPorTipoPergunta(121);
        //     this.props.getOSContagemPorTipoPergunta(122);
        //     this.props.getOSContagemPorTipoPergunta(123);
        // }
    }


    renderLoadingScreen() {
        const { classes } = this.props;
        return (
            <React.Fragment>
                <div align="center">
                    <CircularProgress className={classes.progress} />
                </div>
            </React.Fragment>
        )
    }

    renderContent(){
        const { classes } = this.props;

        const p121 = this.props.osContagemPorTipoPergunta.find(c => c.tipoPergunta === 121);
        const p122 = this.props.osContagemPorTipoPergunta.find(c => c.tipoPergunta === 122);
        const p123 = this.props.osContagemPorTipoPergunta.find(c => c.tipoPergunta === 123);

        console.log(this.props);

        return (<Grid container direction="column">
            <Grid container item direction="row" alignItems="stretch" spacing={16}>


                <Grid item xs={12} className={classes.marginBottom}>
                    <ConsertoKPI isLoading={this.props.isLoading}  dados={this.props.conserto}  filter={this.props.filter} />
                </Grid>

                <Grid item xs={12} className={classes.marginBottom}>
                    <OSESeriesDHChart isLoading={this.props.isLoading} series={this.props.conserto.distribuicaoDataHora}
                                      filter={this.props.filter} title="RITMO POR HORA"/>
                </Grid>

                {p121 && p121.contagem.length > 0 &&
                    <Grid item xs={12} className={classes.marginBottom}>
                        <OSRespostasBarChart isLoading={this.props.isLoading} series={p121 ? p121.contagem : []}
                                             filter={this.props.filter} title="ITEM"/>
                    </Grid>
                }
                {p122 && p122.contagem.length > 0 &&
                    <Grid item xs={12} className={classes.marginBottom}>
                        <OSRespostasPieChart isLoading={this.props.isLoading} series={p122 ? p122.contagem : []}
                                             filter={this.props.filter} title="LIGACAO"/>
                    </Grid>
                }
                {p123 && p123.contagem.length > 0 &&
                    <Grid item xs={12} className={classes.marginBottom}>
                        <OSRespostasPieChart isLoading={this.props.isLoading} series={p123 ? p123.contagem : []}
                                             filter={this.props.filter} title="CINTA DE ACO"/>
                    </Grid>
                }

            </Grid>
        </Grid>)

    }

    //TODO: reactgridlayout https://github.com/STRML/react-grid-layout
    render() {
        const { classes, isLoading } = this.props;

        return (
            <React.Fragment>
                <Grid container direction="column" className={classes.dashboardSection}>
                    <Grid item xs={12}>
                        <FiltersSection showPeriod={true} showBeforePeriod={false}
                                        showBenchPeriod={false} onButtonClick={this.props.getRaspaCycleHourUsageStatistics}
                                        loading={this.props.loading} onFilterClick={this.onFilterClick}/>
                    </Grid>
                </Grid>
                <Grid item  xs={12} sm={12} lg={12} xl={12}>
                    <Typography variant="h4" align="center" className={classes.sectionTitle}>
                        CONSERTO
                    </Typography>
                </Grid>
                { isLoading ? this.renderLoadingScreen() : this.renderContent() }
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        conserto: state.ordemServicoReducer.conserto,
        loading : state.ordemServicoReducer.isFetchingEstatisticaEtapa,
        filter: state.filter,
        osContagemPorTipoPergunta: state.ordemServicoReducer.osContagemPorTipoPergunta,
        fullreducer: state,
    }
}


export default connect(mapStateToProps, {getEstatisticaEtapa, getOSContagemPorTipoPergunta} ) (withStyles(styles, {withTheme: true})(Conserto));
